module.exports = __webpack_public_path__ + "static/media/Engadin_Slider_3.e1b31d8f.jpg";